module.exports = __webpack_public_path__ + "static/ninoyaxel-56b43d081c1564975fe447c6a5df5ae9.jpg";